import throttle from 'lodash-es/throttle'
import { on } from '@utils/events.js'
import http from '@utils/http.js'
import { putContent } from '@utils/html.js'
import { slideTo } from '@utils/animation.js'
import { trackEvent } from '@modules/tracking/tracking.js'
import { translate } from '@modules/locale/locale.js'
import { userPhotoGallery } from '@modules/photoswipe/userPhotoGallery.js'
import { headerHeight } from '@modules/header/header.js'
import { useReviewsStore } from '@store/reviews.js'
import { watch } from 'vue'
;(function () {
    const placeProfile = document.querySelector('.place-profile')

    if (!placeProfile) {
        return
    }

    const placeData = JSON.parse(placeProfile.dataset.place)

    import('./claim-place.js')
    import('./unclaim-place.js')

    // Show .js-sticky-nav when scroll reaches element "h1"
    const nav = placeProfile.querySelector('.js-sticky-nav')
    const trigger = placeProfile.querySelector('.js-sticky-nav-trigger')

    if (nav && trigger) {
        const offset = headerHeight(true) || null
        if (nav && trigger) {
            const showStickyIfAboveFold = () => {
                const rect = trigger.getBoundingClientRect()
                const triggerIsAboveFold = rect.top + rect.height < offset

                if (triggerIsAboveFold) {
                    nav.classList.add('tw-translate-y-0')
                } else {
                    nav.classList.remove('tw-translate-y-0')
                }
            }
            document.addEventListener(
                'scroll',
                throttle(() => {
                    requestAnimationFrame(() => {
                        showStickyIfAboveFold()
                    })
                }, 300),
            )
            showStickyIfAboveFold()
        }
    }

    // TODO: Make a global data-user-photo attribute?
    const userPhotosElements = document.querySelectorAll('.place-photos a.user-photo')
    userPhotosElements?.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault()

            userPhotoGallery({
                place: placeData.uuid,
                first: el.dataset.id,
            })
        })
    })

    document.getElementById('user-photo-gallery')?.addEventListener('scroll', (e) => {
        e.target.classList.toggle(
            'at-end',
            e.target.scrollLeft + e.target.offsetWidth >= e.target.scrollWidth,
        )
    })

    trackEvent('Profile visits', {
        category: 'Place',
        label: placeData.name,
        place: placeData.uuid,
        nonInteraction: true,
    })

    // window.thatsup.place.reviewList(placeProfile.querySelector('.user-reviews'), {})

    const reviewContainer = placeProfile.querySelector('#reviews')
    if (reviewContainer) {
        const HAS_EXPANDED_PLACE_REVIEWS_KEY = 'reviews_expanded_' + placeData.uuid

        let lastReviewPageParams = {}

        const expandReviews = () => {
            reviewContainer.classList.add('is-expanded')
            reviewContainer.setAttribute('aria-expanded', 'true')
            window.sessionStorage?.setItem(HAS_EXPANDED_PLACE_REVIEWS_KEY, true)
        }

        const loadReviewPage = (params, slide = true) => {
            expandReviews()
            const reviewList = reviewContainer.querySelector('.js-review-list')
            reviewList.querySelector('.js-review-list').classList.add('is-loading-async-html')
            if (slide) {
                slideTo(reviewList)
            }

            const newParams = { ...lastReviewPageParams, ...params }

            reviewContainer.querySelectorAll('.js-review-paging a[data-page]').forEach((el) => {
                el.parentNode.classList.toggle(
                    'active',
                    parseInt(el.dataset.page) === (newParams.page || 1),
                )
            })
            reviewContainer.querySelectorAll('.js-review-sorting a[data-sort]').forEach((el) => {
                el.parentNode.classList.toggle(
                    'active',
                    el.dataset.sort === (newParams.sort || 'relevance'),
                )
            })
            const countContainer = reviewContainer.querySelector('.js-review-paging *[data-count]')
            if (countContainer) {
                countContainer.innerText = translate('page_x_of_y', {
                    page: newParams.page || 1,
                    total: countContainer.dataset.count,
                })
            }

            return http
                .get(`/place/${placeData.uuid}/reviews`, { params: newParams })
                .then(async (response) => {
                    lastReviewPageParams = newParams
                    await putContent(reviewList, response.data)
                })
                .finally(() => {
                    reviewList
                        .querySelector('.js-review-list')
                        .classList.remove('is-loading-async-html')
                })
        }

        const reviewStore = useReviewsStore()
        const userReview = reviewStore.getReviewForUser(placeData.uuid)
        watch(
            () => userReview.value,
            (newVal, oldVal) => {
                if (oldVal && oldVal.pending) {
                    // Reload the review list if the user has submitted a new review
                    loadReviewPage({ page: 1, sort: undefined }, false)
                }
            },
            { deep: false },
        )

        on('click', reviewContainer, '.js-review-paging a[data-page]', (e) => {
            e.preventDefault()
            loadReviewPage({ page: parseInt(e.target.dataset.page) })
        })
        on('click', reviewContainer, '.js-review-sorting a[data-sort]', (e) => {
            e.preventDefault()
            loadReviewPage({ sort: e.target.dataset.sort, page: 1 })
        })
        on('click', reviewContainer, '.js-reviews-filtered-reveal', () => {
            reviewContainer.classList.toggle('filtered-revealed')
        })
        const expandButton = reviewContainer.querySelector('.js-reviews-expand')
        if (expandButton) {
            expandButton.addEventListener('click', expandReviews)
            if (window.sessionStorage?.getItem(HAS_EXPANDED_PLACE_REVIEWS_KEY)) {
                expandReviews()
            } else {
                reviewContainer.setAttribute('aria-expanded', 'false')
            }
        }
    }

    const openingHoursLinks = document.querySelectorAll('.opening-hours-link')
    openingHoursLinks.forEach((openingHoursLink) => {
        openingHoursLink.addEventListener('click', () => {
            trackEvent('Opening hours', {
                category: 'Place',
                label: placeData.name,
                place: placeData.uuid,
            })

            openingHoursLink.querySelector('i').classList.toggle('rotate-180')

            openingHoursLink.previousElementSibling.classList.toggle('tw-hidden')
        })
    })
})()
